import React from "react";
import { useState } from "react";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import "../../utils/comman/Dashboard.css";
import Select from "react-select";
import { toast } from "react-toastify";
import { MdDelete } from "react-icons/md";
import { FaUserEdit } from "react-icons/fa";
import { RiUserFill } from "react-icons/ri";
import { RiUserForbidFill } from "react-icons/ri";
import { MdContentCopy } from "react-icons/md";
import { useEffect } from "react";
import TooltipLite from "react-tooltip-lite";
import { useSelector } from "react-redux/es/exports";
import Pagination from "../../utils/Pagination";
import axiosinstances from "../../Helper/useAxios";
import { v4 as uuid4 } from "uuid";
import {
  copyTextToClipboard,
  dangerColor,
  isSuperAdmin,
  isUserAdmin,
  primaryColor,
  showpageCount,
  stylesofStype,
} from "../../utils/comman/Common";
import { Tooltip } from "react-tooltip";
import {
  setpageContent,
  Statusoptions,
  searchbyOptions,
} from "../../utils/Constant";

import moment from "moment";
import Head from "./Head";
import { useNavigate } from "react-router-dom";
import { appVersion } from "../../version";

const UserList = () => {
  const profileInfo = useSelector(
    (state) => state.getprofilereducer?.getprofile
  );

  const sessionId = useSelector(
    (state) => state.getprofilereducer?.getprofile?.sessionId
  );
  const reqId = useSelector(
    (state) => state.getprofilereducer?.getprofile?.requestId
  );

  const e = JSON.parse(sessionStorage.getItem("token"));

  const userIp = useSelector((state) => state.userIpAddReducer.ip);
  const [axiosInstance] = axiosinstances(userIp);
  const selectedId = useSelector((state) => state.selectedRetailerReducer.id);
  const id = useSelector((state) => state.getprofilereducer?.getprofile?.id);
  const [statusOption, setStatusOption] = useState(Statusoptions);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [isExportable, setIsExportable] = useState(false);
  const [finalSelectedStatus, setFinalSelectedStatus] = useState();
  const [search, setsearch] = useState("");
  const [searchTyping, setSearchTyping] = useState(false);
  const [formDate, setFormDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  //statusDate\
  const [isStatusFilter, setIsStatusFilter] = useState(false);
  const today = new Date().toISOString().split("T")[0];
  const [statusDate, setStatusDate] = useState(today);
  const [paginationDetails, setPaginationDetails] = useState({
    currentPage: 1,
    postsPerPage: 20,
    totalPost: 0,
    totalPages: 0,
  });
  const [searched, setSearched] = useState({
    name: "",
    typing: false,
    typingTimeout: 0,
  });

  const [table, settable] = useState([]);
  const [backupTableData, setBackupTableData] = useState([]);

  const [dataLoading, setDataLoading] = useState(false);
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  const [transactionStatuswithAmount, setTransactionStatuswithAmount] =
    useState([
      {
        id: "SUCCESS",
        count: 0,
        total: 0,
      },
      {
        id: "PENDING",
        count: 0,
        total: 0,
      },
      {
        id: "FAILED",
        count: 0,
        total: 0,
      },
    ]);

  const [searchedBy, setSearchedBy] = useState();
  const [searchedByItem, setSearchedByItem] = useState(searchbyOptions);
  const [searchedByItemShow, setSearchedByItemShow] = useState(true);
  const [selectedTraxn, setSelectedTraxn] = useState(null);
  const [attachmentId, setattachmentId] = useState(null);
  const [isCalledSatausApi, setIsCalledSatausApi] = useState(false);

  const [show, setShow] = useState(false);

  const mid = JSON.parse(sessionStorage.getItem("mid"));
  const storeData = useSelector(
    (state) => state?.configDetailsreducer?.details
  );

  const [warningShown, setWarningShown] = useState(false);
  const currentVersionfromApi =
    (Array.isArray(storeData) &&
      storeData.filter(
        (val) => val.id == "REACT_APP_QRBONPAY_MER_PORTAL_CUREENT_VERSION"
      )) ||
    [];
  useEffect(() => {
    if (
      appVersion &&
      Array.isArray(currentVersionfromApi) &&
      currentVersionfromApi.length > 0
    ) {
      const apiCurrentVersion = currentVersionfromApi[0]?.value;
      if (apiCurrentVersion !== appVersion && !warningShown) {
        toast.warn(
          `Kindly reload your application, a new version ${apiCurrentVersion} is available.`
        );
        setWarningShown(true); // Set the flag to prevent further warnings
      }
    }
  }, [currentVersionfromApi, appVersion, warningShown]);
  const finalStatus = selectedStatus.map((item) => item.value);
  const url = `${process.env.REACT_APP_USER_LITS}?mid=${mid}`;

  const navigate = useNavigate();
  var request = {
    mid: mid,
    requestId: "",
    orderCode: "",
    txnId: "",
    utr: "",
    vpa: "",
    fromDate: null,
    toDate: null,
    statusList: [],
    pageNum: 0,
    perPage: paginationDetails.postsPerPage,
  };
  const [ticketRequest, setticketRequest] = useState({
    merchantId: "",
    type: "",
    txnId: "",
    createdBy: profileInfo?.id,
    description: "",
    userUtr: "",
    userTxnDate: "",
    comments: "",
    attachmentId: "",
  });

  const getUniqId = () => {
    const uuid = uuid4();
    const uuidWithoutDashes = uuid.replace(/-/g, "").toUpperCase();
    return uuidWithoutDashes;
  };

  const increaseOneDate = (date) => {
    console.log("datedate", date);
    if (date !== undefined && date !== null && date !== "") {
      return moment(date).add(1, "day").format("YYYY-MM-DD");
    } else {
      return null;
    }
  };
  const editUser = (data) => {
    // setPersonalDetails({ ...data });
    // setShowModel(true);
    navigate("/user-managment", {
      state: { data: data, headers: headers, isUpdate: true },
    });
  };

  useEffect(() => {
    callApis(url);
  }, []);

  function validateUTR(utr) {
    // Check if UTR is exactly 12 digits
    if (!/^\d{12}$/.test(utr)) {
      return false;
    }

    // Get the last digit of the current year
    const currentYearLastDigit = new Date().getFullYear().toString().slice(-1);

    // Get the last two digits of the previous year
    const previousYearLastTwoDigits = (new Date().getFullYear() - 1)
      .toString()
      .slice(-2);

    // Get the current month and day
    const currentMonth = new Date().getMonth() + 1; // Add 1 to get the month number (January is 1, December is 12)
    const currentDay = new Date().getDate();

    // Check if today is January 1st and the UTR corresponds to December 31st of the previous year
    if (currentMonth === 1 && currentDay === 1) {
      // customLog("utr", utr);
      // customLog(utr[0], previousYearLastTwoDigits[1]);
      if (utr[0] === previousYearLastTwoDigits[1]) {
        return true;
      }
    }

    // Check if the first digit of the UTR matches the last digit of the current year
    if (utr[0] !== currentYearLastDigit) {
      return false;
    }

    return true;
  }
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  useEffect(() => {
    setSearchedByItemShow(true);
    setSearchedBy();
  }, [search]);

  const handalpageclick = async (index) => {
    request["fromDate"] = isStatusFilter ? statusDate : formDate;
    request["toDate"] = isStatusFilter
      ? increaseOneDate(statusDate)
      : increaseOneDate(toDate);
    request["statusList"] = finalStatus;
    request["pageNum"] = index - 1;
    request["perPage"] = paginationDetails.postsPerPage;

    if (url && request) {
      callApis(url, request);
      setPaginationDetails((prev) => {
        return { ...prev, currentPage: index };
      });
    }
  };
  const enterTxnsearch = (event) => {
    event.preventDefault();

    setsearch(event.target.value);
  };

  const addTimeTodate = (date) => {
    const nextDay = moment(date).add(1, "day").format("YYYY-MM-DD");
    return `${nextDay}T00:00:00`;
  };
  const addTimeFromdate = (date) => {
    return `${date}T00:00:00`;
  };

  const headers = {
    Authorization: `Bearer ${e}`,
    "client-id": sessionId,
    "request-id": reqId,
  };
  async function callApis(url, request) {
    await fetchpagedata(url, request);
  }
  const fetchpagedata = async (url) => {
    setDataLoading(true);
    try {
      const res = await axiosInstance.get(url, { headers });

      if (res.status === 200 && res?.data !== undefined) {
        settable(res.data);
        setBackupTableData(res.data);
        setDataLoading(false);
        setIsDataLoaded(true);
        setPaginationDetails((prev) => {
          return {
            ...prev,
            currentPage: res.data?.pageNum + 1,
            totalPost: res.data?.totalCount,
            totalPages: res.data?.pages,
          };
        });
      } else {
        throw new Error(res?.response?.data?.message);
      }
    } catch (error) {
      setDataLoading(false);
      setIsDataLoaded(false);
      console.error("Error", error);

      toast.error(error?.message);
      return false;
    }
  };
  const openChangeStatusAndDelet = async (e, data) => {
    e.preventDefault();

    const API_ENDPOINT = `/api/v1/upi/merchant/user/delete/${data.id}`;
    try {
      const response = await axiosInstance.post(
        API_ENDPOINT,
        {},
        {
          headers,
        }
      );

      if (response.status === 200 && response?.data?.name !== undefined) {
        // console.log("response", response);
        toast.success(`User Deleted`);
        callApis(url);
      } else {
        // console.log("res", response);
        throw new Error(response?.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);

      toast.error(error?.message);
      return false;
    }
  };
  const updateStatus = async (e, data) => {
    e.preventDefault();

    let updateData = { ...data };

    updateData.enabled = !data.enabled;
    const API_ENDPOINT = "/api/v1/upi/merchant/user/update";
    try {
      const requestPayload = {
        ...updateData,
      };

      const response = await axiosInstance.post(API_ENDPOINT, requestPayload, {
        headers,
      });

      if (response.status === 200 && response?.data?.name !== undefined) {
        // console.log("response", response);
        toast.success(`Updated User details ${response?.data?.name}`);
        callApis(url);
      } else {
        // console.log("res", response);
        throw new Error(response?.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);

      toast.error(error?.message);
      return false;
    }
  };

  const applyStatus = (e) => {
    e.preventDefault();
    setIsExportable(true);
    const finalStatus = selectedStatus.map((item) => item.value);

    const request = {
      mid: "",
      requestId: "",
      orderCode: "",
      txnId: "",
      utr: "",
      vpa: "",
      fromDate: formDate,
      toDate: toDate,
      statusList: finalStatus,
      pageNum: paginationDetails.currentPage - 1,
      perPage: paginationDetails.postsPerPage,
    };
    // if (url && request) {
    //   callApis(url, request);
    // }
  };
  const getCurrentDateTime = () => {
    const currentDate = new Date();
    const formattedDate = currentDate
      .toISOString()
      .slice(0, 10)
      .replace(/-/g, "");
    const formattedTime = currentDate
      .toTimeString()
      .slice(0, 8)
      .replace(/:/g, "");
    return `${formattedDate}_${formattedTime}`;
  };
  const convertToXLSX = (data, fileName) => {
    const parsedData = Papa.parse(data, { header: true });
    const worksheet = XLSX.utils.json_to_sheet(parsedData.data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `${fileName}.xlsx`);
  };
  const onExportData = async () => {
    const expFileLength = 10000;
    const request = {
      mid: mid,
      requestId: "",
      orderCode: "",
      txnId: "",
      utr: "",
      vpa: "",
      fromDate:
        formDate !== undefined && formDate !== null && formDate !== ""
          ? addTimeFromdate(formDate)
          : null,
      toDate:
        toDate !== undefined && toDate !== null && toDate !== ""
          ? addTimeTodate(toDate)
          : null,
      statusList: finalStatus,
      pageNum: 0,
      perPage: expFileLength,
    };
    const fetchExportdata = async (url, request) => {
      setDataLoading(true);
      const response = await axiosInstance
        .post(url, request, { headers })
        .then((res) => {
          setDataLoading(false);
          setIsDataLoaded(false);
          const fileName = `${getUniqId()}_${getCurrentDateTime()}`;
          convertToXLSX(res?.data, fileName);
        })
        .catch((err) => {
          console.log(err);
          setDataLoading(false);
          setIsDataLoaded(false);
          // toast.error("Something went wrong");
        });

      if (response) {
        return response.data;
      }
      return false;
    };
    const url = "/api/v1/upi/q/payin/report";

    if (url && request) {
      const fileExport = await fetchExportdata(url, request, { headers });
    }
  };
  const AddNewClients = () => {
    navigate("/user-managment", { state: { isUpdate: false } });
  };
  const resetApply = () => {};
  const fromDateHandler = (e) => {
    setFormDate(e.target.value);
  };
  const toDateHandler = (e) => {
    setToDate(e.target.value);
  };
  const changeHandler = (select) => {
    setSelectedStatus(select);
  };

  const checkDisable = () => {
    let disabled = true;
    if (finalSelectedStatus !== undefined && finalSelectedStatus.length > 0) {
      disabled = false;
    } else if (formDate !== "") {
      disabled = false;
    } else if (toDate !== "") {
      disabled = false;
    }
    return disabled;
  };

  //   const handleFileChange = async (e) => {
  //     const file = e.target.files[0];
  //     const res = await uploadFile(file);
  //   };

  const showAllRole = (roles) => {
    return roles.toString();
  };

  const clearSearchData = () => {
    setsearch("");
  };

  // const percentage = 66;

  const initialValue = 0;
  const sumOfallSatus = transactionStatuswithAmount.reduce(
    (accumulator, currentValue) => accumulator + (currentValue?.count || 0),
    initialValue
  );

  const bgColor = search.length > 3 ? "#FEC7B4" : "#848587";
  const filterDatas = () => {
    if (search !== "") {
      return table.filter(
        (item) =>
          item?.name.toLowerCase().includes(search.toLowerCase()) ||
          item?.email.toString().includes(search) ||
          item?.mobile.toString().includes(search) ||
          item?.id.toString().includes(search)
      );
    } else {
      return table;
    }
  };
  const filterData = filterDatas();
  console.log("filterData", filterData);
  return (
    <React.Fragment>
      {
        <>
          <Tooltip id="txn-tooltip" effect="solid" />
          <div className="mid">
            <div className="container-fluid">
              <div className="maincard">
                <div className="tab-content" id="mobiletab">
                  <div
                    className="tab-pane fade show active"
                    id="nav-mobi"
                    role="tabpanel"
                    aria-labelledby="mobile-tab"
                  >
                    <Head
                      //  bgColor={bgColor}
                      //  AddNewClients={AddNewClients}
                      {...{
                        AddNewClients,
                        search,
                        enterTxnsearch,
                        clearSearchData,
                        bgColor,
                      }}
                    />
                    <div className="txn-list" id="recntxn">
                      {dataLoading ? (
                        <div className="d-flex justify-content-center">
                          <div className="spinner-border" role="status">
                            <span className="sr-only">Loading...</span>
                          </div>
                        </div>
                      ) : (
                        <>
                          {filterData !== undefined &&
                          filterData !== null &&
                          isDataLoaded &&
                          filterData.length == 0 ? (
                            <h6>No Record Found</h6>
                          ) : filterData !== undefined &&
                            filterData == null &&
                            isDataLoaded ? (
                            <h6>No Record Found</h6>
                          ) : (
                            filterData?.map((data) => {
                              return (
                                <div className="txn-item" key={data.id}>
                                  <div className="txn-head" id="txnhead1">
                                    <div
                                      className="collapsed"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#txn1"
                                      aria-expanded="false"
                                      aria-controls="txn1"
                                    >
                                      <div
                                        className={`txncard ${
                                          data.enabled
                                            ? "success grbg"
                                            : "failed rdbg"
                                        }`}
                                      >
                                        <div className="row">
                                          <div className="col-12 col-md-2">
                                            <div className="txntxt">
                                              <h6>
                                                <span>
                                                  {" "}
                                                  {data?.createdOn !==
                                                    undefined &&
                                                    data?.createdOn !== null &&
                                                    data?.createdOn
                                                      .replace("T", " ")
                                                      .slice(0, -4)}{" "}
                                                </span>{" "}
                                                {/* ₹ {data.transaction.amount}{" "} */}
                                              </h6>
                                              <h6>{data?.name}</h6>
                                            </div>
                                          </div>
                                          <div className={`col-12  col-md-3`}>
                                            <div
                                              className="txntxt"
                                              onClick={() =>
                                                copyTextToClipboard(
                                                  data?.email,
                                                  toast
                                                )
                                              }
                                            >
                                              <h5>
                                                <h6>
                                                  Email: {data?.email}{" "}
                                                  <MdContentCopy
                                                    style={{
                                                      color: primaryColor,
                                                    }}
                                                  />
                                                </h6>
                                              </h5>
                                              {/* </li> */}
                                            </div>
                                            <div
                                              className="txntxt"
                                              onClick={() =>
                                                copyTextToClipboard(
                                                  data?.mobile,
                                                  toast
                                                )
                                              }
                                            >
                                              <h5>
                                                <h6>
                                                  Mobile: {data?.mobile}{" "}
                                                  <MdContentCopy
                                                    style={{
                                                      color: primaryColor,
                                                    }}
                                                  />
                                                </h6>
                                              </h5>
                                              {/* </li> */}
                                            </div>
                                          </div>

                                          <div
                                            // className="col-12 col-md-3"
                                            className="col-12 col-md-4"
                                          >
                                            <div className="txntxt">
                                              <h6
                                                onClick={() =>
                                                  copyTextToClipboard(
                                                    data?.mid,
                                                    toast
                                                  )
                                                }
                                              >
                                                Mid: {data?.mid}{" "}
                                                <MdContentCopy
                                                  style={{
                                                    color: primaryColor,
                                                  }}
                                                />
                                              </h6>
                                              <h6>
                                                Roles:{" "}
                                                {showAllRole(data?.roles)}{" "}
                                              </h6>
                                            </div>
                                          </div>
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                            }}
                                            className="col-12 col-md-3"
                                          >
                                            <div>
                                              <h4
                                                onClick={() => editUser(data)}
                                              >
                                                <FaUserEdit
                                                  size={30}
                                                  style={{
                                                    color: primaryColor,
                                                  }}
                                                />
                                              </h4>
                                            </div>
                                            {
                                              <div>
                                                <h4
                                                  onClick={(e) =>
                                                    openChangeStatusAndDelet(
                                                      e,
                                                      data
                                                    )
                                                  }
                                                >
                                                  <MdDelete
                                                    size={30}
                                                    style={{ color: "#bf4b43" }}
                                                  />
                                                </h4>
                                              </div>
                                            }
                                            {
                                              <div>
                                                {
                                                  data?.enabled ? (
                                                    <h4
                                                      onClick={(e) =>
                                                        updateStatus(e, data)
                                                      }
                                                    >
                                                      <RiUserFill
                                                        size={30}
                                                        style={{
                                                          color: primaryColor,
                                                        }}
                                                      />
                                                    </h4>
                                                  ) : (
                                                    <h4
                                                      onClick={(e) =>
                                                        updateStatus(e, data)
                                                      }
                                                    >
                                                      <RiUserForbidFill
                                                        size={30}
                                                        style={{
                                                          color: dangerColor,
                                                        }}
                                                      />
                                                    </h4>
                                                  )
                                                  //RiUserFill
                                                }
                                              </div>
                                            }
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                          )}

                          <div className="pager">
                            <p>
                              {Array.isArray(filterData) &&
                                showpageCount(0, filterData?.length)}
                              {/* {Array.isArray(table) && checkPermission(MERCHANTLIST_EXPORT_BUTTON_VIEW, roles) && (
                            <button
                              class="lbbtn"
                              type="button"
                              onClick={exportData}
                            >
                              Export
                            </button>
                          )} */}
                            </p>

                            {paginationDetails.totalPost !== undefined &&
                              paginationDetails.totalPost !== null &&
                              paginationDetails.totalPost > 10 &&
                              search == "" && (
                                <Pagination
                                  className="pagination-bar"
                                  currentPage={paginationDetails.currentPage}
                                  totalCount={paginationDetails.totalPost}
                                  pageSize={paginationDetails.postsPerPage}
                                  onPageChange={(page) => handalpageclick(page)}
                                />
                              )}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      }
    </React.Fragment>
  );
};

export default UserList;
